import { Datatype } from '@framework/engine/schema/expressions/datatype/Datatype.ts';
import {
  type IReference,
  ReferenceType,
} from '@framework/engine/schema/expressions/references/IReference.ts';
import {
  createSubjectReference,
  type ISubjectReferenceStructure,
} from '../common/createSubjectReference.ts';

function createReference(
  datatype: Datatype.String | Datatype.Number | Datatype.Date | Datatype.File,
  code: string,
  label: string,
): IReference {
  return createSubjectReference({
    datatype,
    code,
    prefixLabel: 'Titolare o Utente Attivo',
    label,
    idPrefix: 'titolare_o_richiedente',
    referenceType: ReferenceType.Metadata,
    referenceSubtype: 'applicantOrUser',
    group: 'Titolare o Utente Attivo',
  });
}

const applicantOrUserReferenceStructure: ISubjectReferenceStructure[] = [
  {
    datatype: Datatype.String,
    code: 'nome',
    label: 'Nome',
  },
  {
    datatype: Datatype.String,
    code: 'cognome',
    label: 'Cognome',
  },
  {
    datatype: Datatype.String,
    code: 'email',
    label: 'Email',
  },
  {
    datatype: Datatype.String,
    code: 'codiceFiscale',
    label: 'Codice Fiscale',
  },
];

/**
 * Ritorna la lista delle possibili reference del tipo "Titolare o Utente Attivo: <...>".
 * L'engine andrà poi a recuperare i dati del titolare (se presente) o dell'utente attivo.
 */
export function getApplicantOrUserReferences(): IReference[] {
  return applicantOrUserReferenceStructure.map(refData =>
    createReference(refData.datatype, refData.code, refData.label),
  );
}
